import { connect } from 'react-redux'
import { doChatBootstrap } from 'ducks/chat/actions/bootstrap'
import { doSyncRooms } from 'ducks/chat/actions/rooms'
import { selectUpdatingMatrixRoomIds } from 'ducks/chat/selectors/rooms'
import {
  selectChatTitleName,
  selectChatTitleCount,
} from 'ducks/chat/selectors/title'
import withMatrixClient from './components/withMatrixClient'
import router from './router'

export { routes, registerPageReducer } from './routes'

const select = state => ({
  skipUnreadyRender: true,
  updatingMatrixIds: selectUpdatingMatrixRoomIds(state),
  titleName: selectChatTitleName(state),
  titleCount: selectChatTitleCount(state),
})

const perform = {
  bootstrapChat: doChatBootstrap,
  onRoomsUpdated: doSyncRooms,
}

export default connect(select, perform)(withMatrixClient(router))
